export { default } from './ProductCardModal';
